module.exports = __webpack_public_path__ + "assets/img/feel_clear.9f0c7896.svg";